
    
    import axios, { AxiosResponse } from 'axios';
    import { defineComponent } from 'vue';

    export class matoscompletion {
        public id: string = "";
        public label: string = "";
    }

    export default defineComponent({
        data() {
            return {
                input:"",
                oldvalue:"",
                value: null,
                display: null,
                results: null as matoscompletion[]|null,
                timeout: 0 as any,
                selectedIndex: null as number | null
            };
        },
        props: {
            placeholder: String,
            source: Function,
            resultsDisplay: Function,
            resultsValue: String,
            maxresults: {
                type: Number,
                default: 5
            },
        },
        computed: {
            inputvalue: {
                get():string {
                    return this.input;
                },
                set(val: string) {
                    if (this.oldvalue == val)
                        return;
                    this.oldvalue = val;
                    if (this.timeout) clearTimeout(this.timeout)
                    this.timeout = setTimeout(() => {
                        this.input = val;
                        this.selectedIndex = null;
                        if (this.source != null) {
                            if (this.input.length <= 0)
                                return;
                            const url = this.source(this.input);
                            let self = this;
                            let response = axios.post<matoscompletion[]>(url).then(function (response: AxiosResponse<matoscompletion[]>) {
                                if (response.data !== null) {
                                    self.results = response.data.slice(0, self.maxresults);
                                }
                            });
                        }
                    }, 200)
                }
            }
        },
        methods: {
            isSelected(key:any) {
                return key === this.selectedIndex;
            },
            up() {
                if (this.results == null)
                    return;
                if (this.selectedIndex === null) {
                    
                    this.selectedIndex = this.results.length - 1;
                    return;
                }
                this.selectedIndex = (this.selectedIndex === 0) ? this.results.length - 1 : this.selectedIndex - 1;
            },
            down() {
                if (this.results == null)
                    return;
                if (this.selectedIndex === null) {
                    this.selectedIndex = 0;
                    return;
                }
                this.selectedIndex = (this.selectedIndex === this.results.length - 1) ? 0 : this.selectedIndex + 1;
            },
            enter() {
                if (this.results == null)
                    return;
                if (this.selectedIndex === null) {
                    return;
                }
                this.select_result(this.results[this.selectedIndex]);
                this.$emit('enter', this.display);
            },
            close() {
                this.results = null;
                this.$emit('close');
            },
            select_result(item:any) {
                this.value = (this.resultsValue && item[this.resultsValue]) ? item[this.resultsValue] : item.id;
                if (this.resultsDisplay!=null)
                    this.display = this.resultsDisplay(item);
                this.$emit('selected', {
                    value: this.value,
                    display: this.display,
                    selectedObject: item
                });
                this.close();
            }
        },
        mounted() {
            
        }
    });
